// context/useAuth.js
// ─────────────────────────────────────────────────────────────
// FIXED — added a guard so a missing <AuthProvider> ancestor fails
// with a clear, actionable error message instead of silently
// returning undefined and crashing wherever the caller destructures
// it (e.g. "Cannot destructure property 'user' of 'useAuth(...)' as
// it is undefined" — a real error from App.jsx, caused by App not
// being rendered inside <AuthProvider>).
//
// AuthContext.jsx's createContext() has no default value, so
// useContext(AuthContext) returns undefined whenever called outside
// the provider tree — this is correct React behavior, just a
// confusing failure mode at the call site. This guard turns that
// into an immediate, specific error pointing at the actual cause
// (provider missing) instead of a generic destructuring TypeError
// several stack frames away from the real problem.
// ─────────────────────────────────────────────────────────────
import { useContext } from "react";
import { AuthContext } from "./AuthContext";

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (ctx === undefined) {
    throw new Error(
      "useAuth() was called outside of <AuthProvider>. " +
      "Make sure the component tree is wrapped in <AuthProvider> " +
      "(usually in main.jsx/index.jsx, wrapping <App />)."
    );
  }
  return ctx;
}